import {Image} from '@shopify/hydrogen';
import clsx from 'clsx';
import {useState} from 'react';

export const StandardInput = ({
  type = 'text',
  className,
  handleChange,
  backgroundColor,
  ...props
}: any) => {
  return (
    <input
      {...props}
      type={type}
      className={`bg-transparent w-full border-x-0 border-b-4 border-t-0 border-dark-grey pt-2 pb-6 outline-none focus:border-dark-grey focus:ring-0 ${className} placeholder-current rounded-none richH5 placeholder:richH5 appearance-none font-bold text-dark-grey placeholder:text-dark-grey`}
      onChange={handleChange}
      style={{backgroundColor: backgroundColor?.hex}}
    />
  );
};

const IconRadio = ({
  fieldName,
  icon,
  title,
  required,
  handleChange,
  active,
  onClick,
}: any) => {
  return (
    <label className={`richH5 mx-4 font-bold text-dark-grey`}>
      <input
        type="radio"
        name={fieldName}
        value={title}
        required={required}
        className="hidden"
        onChange={handleChange}
      />
      <span
        onClick={onClick}
        className={clsx([
          'transition-standard mb-6 flex h-16 w-16 items-center  justify-center rounded-full border-2 bg-white md:h-20 md:w-20 lg:h-32 lg:w-32',
          active ? 'border-brand ' : 'border-brand/0',
        ])}
      >
        {icon?.asset?.url && (
          <Image
            alt={title || ''}
            width="inherit"
            height="inherit"
            data={{url: icon?.asset?.url}}
            className="w-8 md:w-12 lg:w-16"
          />
        )}
      </span>
      {title}
    </label>
  );
};

export const IconRadios = ({
  fieldName,
  required,
  options,
  handleChange,
}: any) => {
  const [active, setActive] = useState<number>();
  return (
    <div className="mt-15 flex justify-center">
      {options?.map((item: any, i: number) => (
        <IconRadio
          key={i}
          {...item}
          fieldName={fieldName}
          required={required}
          handleChange={handleChange}
          setActive={setActive}
          active={i === active}
          onClick={() => setActive(i)}
        />
      ))}
    </div>
  );
};
